/**
 * Privacy Policy and Terms & Conditions – Indian law, Hyderabad jurisdiction.
 * Contact for data removal and legal requests: legal@gradedplay.com
 * Content is shared with the consent banner via content/LegalContent.js.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { PrivacyPolicyContent, TermsContent, DEFAULT_LEGAL_EMAIL, DEFAULT_SITE_NAME, DEFAULT_SITE_URL } from '../content/LegalContent';
import './Privacy.css';

export default function Privacy() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <header className="privacy-header">
          <h1>Privacy Policy &amp; Terms</h1>
          <p className="privacy-updated">Last updated: February 2025</p>
          <p className="privacy-contact">
            For data removal, access requests, or legal enquiries: <a href={`mailto:${DEFAULT_LEGAL_EMAIL}`}>{DEFAULT_LEGAL_EMAIL}</a>
          </p>
        </header>

        <nav className="privacy-nav" aria-label="Page sections">
          <a href="#privacy-policy">Privacy Policy</a>
          <a href="#terms">Terms &amp; Conditions</a>
        </nav>

        <main className="privacy-content">
          <PrivacyPolicyContent
            legalEmail={DEFAULT_LEGAL_EMAIL}
            siteName={DEFAULT_SITE_NAME}
            siteUrl={DEFAULT_SITE_URL}
            className="privacy-section"
          />
          <TermsContent
            legalEmail={DEFAULT_LEGAL_EMAIL}
            siteName={DEFAULT_SITE_NAME}
            className="privacy-section"
          />
        </main>

        <footer className="privacy-footer">
          <p>
            <Link to="/">Back to home</Link> · Contact: <a href={`mailto:${DEFAULT_LEGAL_EMAIL}`}>{DEFAULT_LEGAL_EMAIL}</a>
          </p>
        </footer>
      </div>
    </div>
  );
}
